import { IntentSource, REDIRECTION_BUTTON_TRIGGER_TYPE } from '../constants';
import { redirectionTo } from '../tools';
import handleClickIntent from './handleClickIntent';
import { initStore, modalStore } from '@/stores/index';

type Props = {
  buttonName: string;
  triggerType: REDIRECTION_BUTTON_TRIGGER_TYPE;
  url: string;
  taskBotId: string;
  taskBotType: string;
  intentId: number;
  disableClick?: boolean;
  dialogueId?: string;
  onClose?: () => void;
  formUrl?: string;
};

const handleArticleRedirectionButtonClick = (data: Props) => {
  const { buttonName, triggerType, url, taskBotId, taskBotType, intentId, disableClick, dialogueId, formUrl, onClose: closePopup } = data;

  if (disableClick) {
    return;
  }

  if (triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.URL) {
    url && redirectionTo(url, undefined, undefined, { closePopup });
  } else if (triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.FORM) {
    formUrl && redirectionTo(formUrl);
  } else if (triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.TASK_BOT || triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT) {
    const params = {
      intent_id: intentId,
      source: IntentSource.RedirectionButton,
      session_id: initStore.sessionId,
      last_trigger_dialogue_id: dialogueId,
    };
    handleClickIntent(buttonName, params);
    modalStore.isShowModalArticle && modalStore.HIDE_ARTICLE_MODAL();
  }
};

export default handleArticleRedirectionButtonClick;
